<template>
  <div class="home">
    <div class="sizeme">
      <p>
        We are Empowered Consumerism and the new campaign of Alliance In Motion Global or AIM Global.
        The main focus of this campaign is to give value to our consumers and aims to provide ordinary
        consumers a chance to become entrepreneurs by consuming the products. There are two divisions
        in this campaign, the online and offline division. We are focusing on our online division,
        where our primary source of reach is social media.
      </p>
      <p>
        To know more, we encourage you to attend our Live webinar via private group page in Facebook.
      </p>
      <a
        :href="opsurl"
        target="_blank"
      >
        <b>OPP Live Webinar</b>
      </a>
        <!-- <input id="copied" v-on:click="copiedText" :value="opsurl"> -->
      <p>
        Please answer the two questions before submitting the request.
      </p>
      <div class="social-media">
        <p>
          Endorser: Mitch Alvarez
        </p>
        <a
          class="fab fa-facebook-messenger"
          style="margin-left:10px;"
          href="https://m.me/106649691112373"
          target="_blank"
        >
        </a>
      </div>
      <p>
        Kindly send me a message po pag naka request na kayo so I can relay the message to the admins para ma approve kayo.
      </p>
    </div>
  </div>
</template>

<script>
// import ImageWall from '@/components/images/ImageWall.vue'
// import TopContent from '@/components/Topcontent.vue'
import db from '../../config/db'

export default {
  name: 'Home',
  components: {
    // ImageWall,
    // TopContent
  },
  data: function () {
    const base = 'https://asvrada.github.io/assets/'
    const listImages = [
      '0.jpg',
      '1.png',
      '2.jpg',
      '3.png',
      '4.jpg'
    ]
    const absolutePath = []
    for (const i in listImages) {
      absolutePath.push(base + listImages[i])
    }
    return {
      listImages: absolutePath,
      mobileView: true,
      opsurl: ''
    }
  },
  mounted () {
    this.opsURL()
    this.$store.commit('checkENV')
  },
  methods: {
    opsURL () {
      const vm = this
      db.firestore.collection('opsURL' + this.$store.state.env)
        .doc('opsURL')
        .get()
        .then(querySnapshot => {
          vm.opsurl = querySnapshot.data().url
        })
    },
    copiedText () {
      const copyText = document.getElementById('copied')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },
    handleView () {
      this.mobileView = window.innerWidth <= 500
    }
  },
  created () {
    this.handleView()
    window.addEventListener('resize', this.handleView)
  }
}
</script>

<style lang="scss">
@import "../assets/common.scss";

.sizeme {
  width: 80%;
  margin: auto;
}

.imageborder {
  box-sizing: border-box;
  border: 1px solid #2c3e50;
}

a {
    text-decoration: none;
    color: $content-colour;
  }

</style>
